var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialNumberDeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2951_50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 20.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.195 17.1622L29.889 13.8197C28.7205 12.6417 27.172 12 25.519 12H20.275C17.919 12 16 13.9346 16 16.3098V30.676C16 33.0512 17.919 34.9858 20.275 34.9858H23.125C23.391 34.9858 23.6 34.7751 23.6 34.5069C23.6 34.2388 23.391 34.0281 23.125 34.0281H20.275C18.4415 34.0281 16.95 32.5244 16.95 30.676V16.3098C16.95 14.4614 18.4415 12.9577 20.275 12.9577H25.5095C25.823 12.9577 26.1365 12.9865 26.45 13.0439V18.2253C26.45 19.547 27.514 20.6197 28.825 20.6197H33.9645C34.0215 20.9262 34.05 21.2422 34.05 21.5678V30.676C34.05 31.8731 33.4135 32.9841 32.3875 33.5779C32.1595 33.712 32.0835 33.9993 32.2165 34.2292C32.3495 34.459 32.644 34.5357 32.8625 34.4016C34.183 33.6354 35 32.1988 35 30.6664V21.5678C35 19.9014 34.354 18.3403 33.195 17.1622ZM28.825 19.6619C28.0365 19.6619 27.4 19.0202 27.4 18.2253V13.3121C28.0745 13.5707 28.6825 13.973 29.205 14.4997L32.511 17.8422C33.0335 18.369 33.4325 18.9915 33.689 19.6619H28.8155H28.825ZM27.875 24.4506C26.0415 24.4506 24.55 25.9543 24.55 27.8027C24.55 28.7126 24.911 29.5458 25.5 30.1492V33.9706C25.5 34.3824 25.747 34.7559 26.127 34.9188C26.2505 34.9667 26.3835 34.9954 26.5165 34.9954C26.7825 34.9954 27.039 34.89 27.229 34.6985L27.875 34.0472L28.521 34.6985C28.8155 34.9954 29.243 35.0816 29.623 34.9188C30.003 34.7559 30.25 34.392 30.25 33.9706V30.1492C30.839 29.5458 31.2 28.7126 31.2 27.8027C31.2 25.9543 29.7085 24.4506 27.875 24.4506ZM27.875 25.4084C29.186 25.4084 30.25 26.4811 30.25 27.8027C30.25 29.1244 29.186 30.1971 27.875 30.1971C26.564 30.1971 25.5 29.1244 25.5 27.8027C25.5 26.4811 26.564 25.4084 27.875 25.4084ZM29.1955 34.0089L27.875 32.6776L26.5545 34.0089L26.45 33.961V30.8292C26.8775 31.0399 27.362 31.1548 27.875 31.1548C28.388 31.1548 28.8725 31.0399 29.3 30.8292V33.961L29.1955 34.0089Z",
    fill: "#6A7988",
    stroke: "#6A7988",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2951_50",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2951_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2951_50",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialNumberDeal);
export default __webpack_public_path__ + "static/media/financial-number-deal.2b6b5e60c076a6ace93a3535e6775901.svg";
export { ForwardRef as ReactComponent };